export const APP_TITLE = "Evidence Compendium - ICER";
